import axios from 'axios'
import wx from 'weixin-js-sdk'

let wxShare = (params) => {
  var UrlHost = window.location.host
  if ((UrlHost && UrlHost.indexOf('newaircloud.com') >= 0 && window.location.protocol === 'https:') || window.location.protocol === 'https:') {
    UrlHost = 'https://' + window.location.host
  } else {
    UrlHost = 'http://' + window.location.host
  }
  // eslint-disable-next-line no-undef
  let _img = gUserConfigDir + '/img/icon.png'

  params.imgUrl = params.imgUrl || _img
  let shareData = {
    title: params.title, // 分享标题
    desc: params.desc, // 分享描述
    link: window.location.href, // 分享链接
    imgUrl: params.imgUrl // 分享图标
  }
  // if (/MicroMessenger/i.test(window.navigator.userAgent)) {
  axios.get(UrlHost + '/api/getWXJSApiConfig?sid=' + params.sid + '&url=' + encodeURIComponent(window.location.href))
    .then((res) => {
      try {
        if (res && res.data && res.data.appId) {
          try {
            let data = res.data
            // eslint-disable-next-line eqeqeq
            if (data && data.secondShare && data.secondShare.secondShareSwitch == 1) {
              // eslint-disable-next-line eqeqeq
              if (data.secondShare.showAbstractType != 2) {
                shareData.desc = data.secondShare.summary || ''
              } else {
                shareData.desc = shareData.desc || data.secondShare.summary || ''
              }
              if (data.secondShare.titlePrefix) {
                shareData.title = data.secondShare.titlePrefix + shareData.title
              }
              if (data.secondShare.titleSuffix) {
                shareData.title = shareData.title + data.secondShare.titleSuffix
              }
              if (data.secondShare.thumbnail && data.secondShare.thumbnail.length > 0) {
                shareData.imgUrl = data.secondShare.thumbnail
              }
            } else {
              if (typeof gUserConfig !== 'undefined') {
                // eslint-disable-next-line no-undef
                if (gUserConfig.appName) {
                  // eslint-disable-next-line no-undef,eqeqeq
                  shareData.title = gUserConfig.wxShowAppNameSite == 1 ? shareData.title + gUserConfig.appName : gUserConfig.appName + shareData.title
                }

                // eslint-disable-next-line no-undef
                if (gUserConfig.wxShowDes) {
                  // eslint-disable-next-line no-undef
                  shareData.desc = gUserConfig.wxShowDes || ''
                }

                // eslint-disable-next-line no-undef,eqeqeq
                if (gUserConfig.wxShowImg == 1 && _img) {
                  shareData.imgUrl = _img
                }
              }
            }
          } catch (e) {
            console.log(e)
          }
          let _wxData = {
            appId: res.data.appId,
            nonceStr: res.data.noncestr, // 必填，生成签名的随机串
            timestamp: res.data.timestamp, // 必填，生成签名的时间戳
            signature: res.data.signature, // 必填，签名
            jsApiList: [
              'onMenuShareTimeline',
              'onMenuShareAppMessage',
              'onMenuShareQQ',
              'onMenuShareQZone'
            ]
          }
          // eslint-disable-next-line no-useless-escape,no-undef,eqeqeq
          if (typeof gUserConfig !== 'undefined' && gUserConfig.openWxLaunch == 1 && navigator.userAgent.match(/MicroMessenger\/([\d\.]+)/)) {
            _wxData.openTagList = ['wx-open-launch-app']
          }
          wx.config(_wxData)
          wx.ready(function () {
            wx.onMenuShareTimeline(shareData)
            wx.onMenuShareAppMessage(shareData)
            wx.onMenuShareQQ(shareData)
            wx.onMenuShareQZone(shareData)
          })
        } else {
          // qq二次分享
          document.querySelector('meta[itemprop=\'name\']').setAttribute('content', shareData.title)
          document.querySelector('meta[itemprop=\'description\']').setAttribute('content', shareData.desc)
          document.querySelector('meta[itemprop=\'image\']').setAttribute('content', shareData.imgUrl)
        }
        if (/(apiconfigtest\.newaircloud\.com)|(http:\/\/127\.0\.0\.1)/.test(window.location.href)) {
          console.table(shareData)
        }
      } catch (e) {
        console.log(e)
      }
    })
    .catch(err => {
      console.log(err)
    })
  // }
}

export default ({wxShare})



// WEBPACK FOOTER //
// ./src/tool/wxShare.js